import { COMPONENT_VALUE_TYPES as types, REGIONS } from 'shared/constants';

const propsSchema = [
  {
    key: 'region',
    label: 'Region',
    type: types.ENUM,
    options: REGIONS
  },
  {
    key: 'url',
    label: 'Banner Click URL',
    type: types.TEXT,
  },
  {
    key: 'useCountdown',
    label: 'Use Countdown',
    type: types.BOOLEAN,
  },
  {
    key: 'startDate',
    label: 'Countdown Start Date',
    type: types.DATETIME,
  },
  {
    key: 'endDate',
    label: 'Countdown End Date',
    type: types.DATETIME,
  },
  {
    key: 'bannerText',
    label: 'Event Text',
    type: types.TEXT,
  },
  {
    key: 'countdownPreText',
    label: 'Countdown Pre Text',
    type: types.TEXT,
  },
  {
    key: 'countdownPostText',
    label: 'Countdown Post Text',
    type: types.TEXT,
  },
  {
    key: 'icon',
    label: 'Icon',
    type: types.ICON,
  },
];

const defaultProps = {
  region: 'US',
  useCountdown: false,
  bannerText: 'Watch the livestream now!',
  icon: 'ff-icon-long-arrow-right',
};

export default {
  title: 'Banner',
  id: 'Banner',
  propsSchema,
  defaultProps
};
